import { Grid } from '@material-ui/core'
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles'
import MUIDataTable from "mui-datatables"
import React from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useHistory } from 'react-router-dom'
import LoadingUI from '../../components/ui/LoadingUI'
import { useAuth } from '../../hooks/auth'
import MvmApi from '../../services/MvmApi'
import utilsDate from '../../utils/Date'
import MvmShedList from '../Concierge/Manage/MvmShedList'
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }
  
const VehiclesOnConcierge: React.FC = () => {
    const history = useHistory()
    const { t: tMvm } = useTranslation("Mvm")
    const { t: tGeneral } = useTranslation("General")
    const {user} = useAuth()

    const { control, handleSubmit, setValue } = useForm<any>(
        {
            defaultValues: { 
                sheds: [],
            }
        })    
    const [selectedMvm, setSelectedMvm] = React.useState<any>(null);

    const { isLoading, isFetching, data } = useQuery('pending', async () => {
        var ret = await MvmApi.searchMvmOnConcierge(user.company.plantID)
        return ret 
    } ,{
        refetchIntervalInBackground: true,
        staleTime: 1000 * 60, //calculado em milisegundos - Propriedade para setar qto tempo o cache fica válido
        refetchInterval: 1000 * 30, //calculado em milisegundos - Propriedade para setar qto tempo vai buscar o cache novamente
    });

    const onSelect = async (currentRowsSelected: any, allRowsSelected: any, rowsSelected: any) => {
        if (allRowsSelected.length > 0)
        {
            setSelectedMvm(data[currentRowsSelected[0].index]);
            const shedList = await MvmApi.getShedListById(data[currentRowsSelected[0].index].mvmId);
            setValue('sheds', shedList);
        }else{
            setSelectedMvm(null);
            setValue('sheds', []);
        }
        
    }
    const columns = [
        {
            name: 'conciergeCode',
            label: tMvm("concierge"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "left",
                  }),
                setCellProps: () => ({
                    align: "left"
                })
            }
            
        },
        {
            name: 'vehiclePlateNumber',
            label: tMvm("vehiclePlateNumber"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: 'shippingSupplierCorporateName',
            label: tMvm("shippingSupplier"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value:any, tableMeta:any, updateValue:any) => {
                    return <span>{`${data![tableMeta.rowIndex].shippingSupplierCorporateName}`}</span>
                }
            }
        },  
        {
            name: 'mvmNumber',
            label: tMvm("mvmNumber"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })
            }
               
        }, 
        {
            name: 'statusExternalQueue',
            label: "Status",
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })
            }
               
        }, 
        {
            name: 'vehicleTypeDescription',
            label: tMvm("vehicleTypeDescription"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                
            }
        }, 
        {
            name: 'shippingCompanySupplierCorporateName',
            label: tMvm("shippingCompanySupplier"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value:any, tableMeta:any, updateValue:any) => {
                    return <span>{`${data![tableMeta.rowIndex].shippingCompanySupplierCorporateName}`}</span>
                }
            }
        }, 
        {
            name: 'deliveryWindowDate',
            label: tMvm("deliveryWindowDate"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value:any, tableMeta:any, updateValue:any) =>
                {
                    return <span>{utilsDate.DateTime(value)}</span>
                }
            }
        }, 
        {
            name: 'scheduleDate',
            label: tMvm("checkInConciergeDate"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value:any, tableMeta:any, updateValue:any) =>
                {
                    return <span>{utilsDate.DateTime(value)}</span>
                }
            }
        },         
        {
            name: 'windowStatusDescription',
            label: tMvm("windowStatus"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        }, 
        {
            name: 'criticalMaterialCallDate',
            label: tMvm("criticalMaterial"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value:any, tableMeta:any, updateValue:any) =>
                {
                    return <span>{ value !== null ? "Sim" : "Não"}</span>
                }
            }
        } 
    ]

    const options = {
        textLabels: {
            body: {
                noMatch: tGeneral('noMatch'),
                toolTip: "",
            },
            pagination: {
                next: tGeneral("next"),
                previous: tGeneral("previous"),
                rowsPerPage: tGeneral("rowsPerPage") + ":",
                displayRows: tGeneral("of"),
            }
        }
    }

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''                    
                }
            },
            MuiTableRow: {
                root: { '&$selected, &$selected:hover': { backgroundColor: '#d9e6f3', } }
            }
        }
    })

    return (
        <>
        
            <p> {tGeneral("totalRecords")}  {data ? data.length : '0'}</p>

            {isLoading || isFetching ? <LoadingUI /> :
                <MuiThemeProvider theme={myTheme}>
                    <MUIDataTable
                        title=""
                        data={data}
                        columns={columns} 
                        options={{
                            ...options,
                            serverSide: true,
                            pagination: false,
                            sort: false,
                            selectToolbarPlacement: "none",
                            filter: false,
                            search: false,
                            download: true,
                            print: false,
                            viewColumns: false,
                            selectableRows: 'single',
                            selectableRowsOnClick: true,
                            onRowSelectionChange: onSelect,
                            selectableRowsHideCheckboxes: true,
                            selectableRowsHeader: false,                            
                        }}
                    />

                    {selectedMvm && (
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <MvmShedList
                                    control={control}
                                    name={"sheds"} 
                                    resumido={true}
                                    mvmNumber={selectedMvm?.mvmNumber}
                                    />
                            </Grid>
                        </Grid>
                    )}                    
                </MuiThemeProvider>
            }
        </>
    )
}
export default VehiclesOnConcierge;
